import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';

import './index.sass';

const { cnBlock, el } = bem('form-field', 'checkbox-field');

const CheckboxField = ({ className, text, comment, error, disabled, showError = false, ...rest }) => {
    return (
        <div className={cnBlock(className, { 'checked': rest.checked, 'invalid': error }) }>
            <label className={ el('label', { 'checked': rest.checked, 'invalid': error  }) } disabled={ disabled }>
                <input { ...rest } type='checkbox' disabled={ disabled }/>
                <div className={ el('text-wrapper') }>
                    <Text tag={ 'div' } className={ el('text') }>{ text }</Text>
                    {comment && <Text tag={ 'div' } className={ el('comment') }>{ comment }</Text>}
                </div>
            </label>
            { showError && error && <div className='form-error'>{ error }</div> }
        </div>
    )
}

export default CheckboxField;
